// src/utils/formatMoney.js
export function formatMoney(amount, currency = "") {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return `${currency} 0.00`;
  }

  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));

  return `${currency} ${formatted}`;
}

export function formatMoneyLoose(val) {
  if (val === "" || val === null || val === undefined) return "";

  const [int, dec] = String(val).split(".");
  const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return dec !== undefined ? `${withCommas}.${dec}` : withCommas;
}